export function getNextCircuitNumber(
  existingCircuits: { name: string }[],
  voltage: string,
): string {
  const takenNames = new Set(existingCircuits.map((c) => c.name));
  const numericMatch = /^(\d+)/.exec(voltage);
  let candidate = numericMatch ? parseInt(numericMatch[1], 10) : 0;
  while (takenNames.has(candidate.toString())) {
    candidate++;
  }
  return candidate.toString();
}

export function sortCircuitsByNumber<T extends { name: string }>(circuits: T[]): T[] {
  return [...circuits].sort((a, b) => {
    const numA = parseInt(a.name);
    const numB = parseInt(b.name);
    const aIsNum = !isNaN(numA);
    const bIsNum = !isNaN(numB);

    if (aIsNum && bIsNum) return numA - numB;
    if (aIsNum) return -1;
    if (bIsNum) return 1;
    return a.name.localeCompare(b.name);
  });
}
